export enum ContractorType {
  Broker,
  InsuranceCompany,
  Carrier,
  Supplier,
  Liquidator,
  Depositary
}
